import { AxiosService } from './axiosService';

export class DataMaintenanceService extends AxiosService {
    async getAllWeatherStations() {
        try {
            const { data } = await this.axios.get("/weather-stations");
            return data.data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postDataMaintenance(query) {
        try {
            const { data } = await this.axios.post(`/dataApi/dataMaintenance`, query);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteFunctionData(body) {
        try {
            const { data } = await this.axios.post(`/dataApi/deleteFunctionData`, body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async calculateFunctions(body) {
        try {
            const { data } = await this.axios.post(`/dataApi/calculateFunctions`, body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getElasticTask(taskId) {
        try {
            const { data } = await this.axios.get(`/getElasticTask/${taskId}`);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async patchWeatherData(body) {
        try {
            const { data } = await this.axios.post(`/dataApi/patchWeatherData`, body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async patchNumericPointData(body) {
        try {
            const { data } = await this.axios.post(`/dataApi/patchNumericPoints`, body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const dataMaintenanceService = new DataMaintenanceService();